import {useMutation, UseMutationResult} from '@tanstack/react-query';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import creatorsUpdaters, {BulkEnqueuedResponse} from '@/api/updaters/creators';

export type BulkThreadsAllVariables = {
  agencyId: string;
  brandId: string;
  searchSessionId: string;
  initialMessage: string;
};

/** Enqueues bulk thread creation for all creators matching the current search filters. */
function useBulkThreadsAll(): UseMutationResult<
  BulkEnqueuedResponse,
  Error,
  BulkThreadsAllVariables
> {
  return useMutation({
    mutationKey: ['creators', 'bulkThreadsAll'],
    mutationFn: creatorsUpdaters.bulkThreadsAll,
    onSuccess: () => {
      raiseFlashMessage({
        status: 'success',
        message: translate('Bulk messages enqueued for all matching creators'),
      });
    },
  });
}

export default useBulkThreadsAll;
